/* Cart Gift Card - in-cart UI behavior (Heny / Eurus theme)
 * Pairs with snippets/ws-cart-gift-card.liquid.
 * Strategy: event delegation on document. Idempotent (no double-binding).
 * Single card design, 2 states: offer+message / added-compact.
 * On add/edit, refresh the cart drawer so the snippet re-renders.
 * Adapted for Eurus: listens to "eurus:cart:*" events; falls back to template-class / pathname for cart page detection.
 */
(function () {
  if (window.__wsGiftCardBound) return;
  window.__wsGiftCardBound = true;

  var PROP = 'הודעה לכרטיס';
  var DISMISS_KEY = 'ws_gc_dismissed';

  var pendingEditMsg = null;

  function isDismissed() {
    try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
  }

  function applyDismissal() {
    if (!isDismissed()) return;
    document.querySelectorAll('[data-ws-gc]').forEach(function (el) {
      // Only hide in offer state (not when card already added to cart)
      if (!el.querySelector('[data-ws-gc-edit]')) {
        el.style.display = 'none';
      }
    });
  }

  function clearPendingEdit() {
    pendingEditMsg = null;
    try { sessionStorage.removeItem('ws_gc_prev_msg'); } catch (e) {}
  }

  function onCartPage() {
    try {
      if (document.body && document.body.classList && document.body.classList.contains('template-cart')) return true;
      if (window.location && window.location.pathname === '/cart') return true;
      if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart') return true;
    } catch (e) {}
    return false;
  }

  function swapSnippet() {
    return fetch('/?section_id=cart-drawer', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-ws-gc]');
        document.querySelectorAll('[data-ws-gc]').forEach(function (live) {
          if (!fresh) {
            if (live.parentNode) live.parentNode.removeChild(live);
          } else {
            live.outerHTML = fresh.outerHTML;
          }
        });
      })
      .catch(function () { /* ignore */ });
  }

  function refreshCart() {
    if (onCartPage()) {
      window.location.reload();
      return;
    }
    // Eurus-native cart refresh signal
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed', { bubbles: true }));
    // Generic signal (no-op if nothing listens)
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function setOpen(root, open) {
    if (!root) return;
    var form = root.querySelector('[data-ws-gc-form]');
    var openBtn = root.querySelector('[data-ws-gc-open]');
    var intro = root.querySelector('[data-ws-gc-intro]');
    if (form) {
      form.hidden = !open;
      form.style.display = open ? '' : 'none';
    }
    if (openBtn) {
      openBtn.hidden = open;
      openBtn.style.display = open ? 'none' : '';
    }
    if (intro) {
      intro.style.display = open ? 'none' : '';
    }
    if (open && form) {
      var ta = form.querySelector('[data-ws-gc-textarea]');
      if (ta) {
        // Let iOS scroll naturally on focus, then nudge again after the
        // keyboard finishes animating (so the textarea stays visible).
        try { ta.focus(); } catch (e) {}
        var scrollTaIntoView = function () {
          try { ta.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
        };
        // Multiple delays cover: pre-keyboard, mid-animation, post-animation
        setTimeout(scrollTaIntoView, 60);
        setTimeout(scrollTaIntoView, 400);
        setTimeout(scrollTaIntoView, 800);
        // visualViewport fires when iOS keyboard fully covers the viewport
        if (window.visualViewport) {
          var vv = window.visualViewport;
          var onVvResize = function () {
            scrollTaIntoView();
          };
          vv.addEventListener('resize', onVvResize);
          // Stop listening once the textarea loses focus
          ta.addEventListener('blur', function () {
            vv.removeEventListener('resize', onVvResize);
          }, { once: true });
        }
      }
    }
  }

  function setAddMode(root, mode) {
    if (!root) return;
    var btn = root.querySelector('[data-ws-gc-form] [data-ws-gc-add]');
    if (!btn) return;
    var txt = btn.querySelector('.ws-gc__btn-text');
    var emoji = btn.querySelector('.ws-gc__btn-emoji');
    if (mode === 'save') {
      if (txt) txt.textContent = 'שמירת השינויים';
      if (emoji) emoji.hidden = true;
    } else {
      if (txt) txt.textContent = 'הוספה לעגלה';
      if (emoji) emoji.hidden = false;
    }
  }

  document.addEventListener('click', function (e) {
    var dismissBtn = e.target.closest('[data-ws-gc-dismiss]');
    if (dismissBtn) {
      e.preventDefault();
      try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (err) {}
      var rootD = dismissBtn.closest('[data-ws-gc]');
      if (rootD) rootD.style.display = 'none';
      return;
    }

    var openBtn = e.target.closest('[data-ws-gc-open]');
    if (openBtn) {
      e.preventDefault();
      var rootO = openBtn.closest('[data-ws-gc]');
      setAddMode(rootO, 'add');
      setOpen(rootO, true);
      return;
    }

    var addBtn = e.target.closest('[data-ws-gc-add]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var root = addBtn.closest('[data-ws-gc]');
      if (!root) return;
      var form = root.querySelector('[data-ws-gc-form]');
      var variantId = form ? parseInt(form.dataset.variantId, 10) : 0;
      if (!variantId) { console.error('[ws-gc] missing variant id'); return; }
      var ta = root.querySelector('[data-ws-gc-textarea]');
      var msg = ta ? (ta.value || '').trim() : '';
      var props = {};
      if (msg) props[PROP] = msg;

      var origLabel = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'מוסיף...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed: ' + r.status);
          return r.json();
        })
        .then(function () { clearPendingEdit(); refreshCart(); })
        .catch(function (err) {
          console.error('[ws-gc] add error', err);
          addBtn.disabled = false;
          addBtn.textContent = origLabel;
          alert('שגיאה בהוספת הכרטיס. נסו שוב.');
        });
      return;
    }

    var cancelBtn = e.target.closest('[data-ws-gc-cancel]');
    if (cancelBtn) {
      e.preventDefault();
      var rootC = cancelBtn.closest('[data-ws-gc]');
      if (!rootC) return;
      var taC = rootC.querySelector('[data-ws-gc-textarea]');
      if (taC) { taC.value = ''; }
      clearPendingEdit();
      setOpen(rootC, false);
      return;
    }

    var editBtn = e.target.closest('[data-ws-gc-edit]');
    if (editBtn) {
      e.preventDefault();
      var key = editBtn.dataset.lineKey;
      var prevMsg = editBtn.dataset.currentMessage || '';
      pendingEditMsg = prevMsg;
      try { sessionStorage.setItem('ws_gc_prev_msg', prevMsg); } catch (e) {}
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('change failed: ' + r.status);
          return r.json();
        })
        .then(function () {
          refreshCart();
          setTimeout(applyPendingEdit, 250);
          setTimeout(applyPendingEdit, 700);
          setTimeout(applyPendingEdit, 1400);
        })
        .catch(function (err) {
          console.error('[ws-gc] edit error', err);
          clearPendingEdit();
        });
      return;
    }
  });

  function applyPendingEdit() {
    if (pendingEditMsg === null) {
      var stored = null;
      try { stored = sessionStorage.getItem('ws_gc_prev_msg'); } catch (e) {}
      if (stored === null) return;
      pendingEditMsg = stored;
    }
    var root = document.querySelector('[data-ws-gc]');
    if (!root) return;
    var ta = root.querySelector('[data-ws-gc-textarea]');
    if (!ta) return;
    if (ta.value && ta.value.trim() !== '') return;
    ta.value = pendingEditMsg;
    setAddMode(root, 'save');
    setOpen(root, true);
  }

  // Listen to both Eurus-native and Impact-style cart events
  ['eurus:cart:items-changed', 'eurus:cart:add-as-bundle', 'eurus:cart:redirect',
   'cart:refresh', 'cart:change', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      swapSnippet().then(function () { applyDismissal(); applyPendingEdit(); });
    });
  });

  applyDismissal();
  applyPendingEdit();
})();
